export const GET_PLAN_CONFIG = '/v4GetPlanConfig';
export const GET_SUBSCRIPTION_PLANS = '/v4GetSubscriptionPlans';
export const SUBSCRIBE_PLAN = '/v4SubscribePlan';
export const VALIDATE_PROMOTION = '/v4ValidatePromotion';
export const GET_CARD_CONNECT_HOST = '/v2GetCardConnectHostATP';
export const GET_ALL_COUNTRIES = '/v2GetAllCountries';
export const CHANGE_SUBSCRIPTION_PAYMENT_METHOD =
  '/v4ChangeSubscriptionPaymentMethod';
export const VALIDATE_UPDATE_SUBSCRIPTION_PLAN =
  '/v4ValidateUpdateSubscriptionPlan';
export const UPDATE_SUBSCRIPTION_PLAN = '/v4UpdateSubscriptionPlan';
export const GET_USER_ACTIVE_STATS = '/v4GetActiveUserStats';
export const GET_SUBSCRIPTION_INVOICE = '/v4GetSubcriptionInvoice';
export const PRINT_SUBSCRIPTION_INVOICE = '/v4PrintSubcriptionInvoice';
export const VIEW_PDF_1500_FROM_ATP = '/v4ViewPDF1500FormATP';
export const SUBSCRIPTION_PLAN_PAYMENT = '/v4SubscriptionPlanPayment';
